import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface TAssignedFeeData {
  // DTA-949: a coupon book the student sold, waiting on a payment link or on
  // money sent to school. Shown as waiting; never auto-added to the cart.
  couponBookWaiting?: 'invitation' | 'school' | null
  couponBookHolder?: string | null
  removable: number
  feeId: number
  description: string
  date: string
  amountDue: number
  feeStatus: string
  allowPartial: boolean
  createdByType: number
  note: string | null
  formSubmissionId: string | null
  formData: string | null
  menuItemId: number
  familyMaxId: number
  variablePricingEnabled: boolean
  disabled: boolean
  enrollmentId: number | null
  onHoldAllowedToPurchase: number | null
  orderItemTypeId: number | null
  /** DTA-1092: the app the fee belongs to (1012 Childcare, 1014 Athletics), or null */
  moduleId?: number | null
}

// GET /ajax/student/{student_account_id}/other_fee/assigned
export const assignedFees = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/other_fee/assigned'
  )
  return Util.Obj.keysToCamel(response.data.items) as TAssignedFeeData[]
}
